function ProjectBayt() {
  return (
    <div>
      <p>
        I work on <strong>YallaMotor</strong>, a leading automotive platform in the Middle East. YallaMotor is owned by <strong>Bayt.com</strong> and offers comprehensive car reviews, listings, and the latest automotive news, helping connect buyers and sellers across the region.
      </p>
      <p>
        My role primarily involves developing and enhancing features on YallaMotor to make car buying and selling easier and more informed. This includes working on user-friendly interfaces and back-end improvements, employing <strong>Ruby on Rails</strong>, and utilizing software development best practices to enhance performance and reliability.
      </p>
      <p>
        Through my work, I contribute to Bayt.com’s mission to provide an accessible and trustworthy automotive marketplace.
      </p>

      <ul>
        <li>Led the enhancement of YallaMotor's backend, resulting in a <strong>30% improvement</strong> in response times and optimized system performance under high traffic.</li>
        <li>Boosted Video Schema Markup for seven regions, improving SEO performance and increasing video visibility.</li>
        <li>Designed and deployed RESTful APIs that streamlined data exchange between microservices, cutting manual processes by <strong>60%</strong>.</li>
        <li>Built CI/CD pipelines with Jenkins and GitHub Actions, reducing release cycles by <strong>50%</strong>. Integrated monitoring tools like New Relic and Sentry to ensure system stability.</li>
        <li>Developed a cloud infrastructure on AWS (EC2, S3, RDS), cutting hosting expenses by <strong>25%</strong> while ensuring scalability.</li>
        <li>Implemented an AI-powered feature for content creators on YallaMotor, allowing automatic article generation using keywords, increasing content production efficiency.</li>
        <li>Spearheaded a new, robust task on YallaMotor's platform that enhances user engagement by generating personalized content suggestions based on user behavior and preferences.</li>
      </ul>
    </div>


  );
}

function ProjectSouthville() {
  return (
    <div>
      <p>
        <strong>Ruby on Rails Developer</strong>
      </p>
      <br />
      <p>
        <strong>Projects:</strong>
      </p>
      <p>
        <strong>
          ECRM (Employee Enterprise Content and Relationship Management)
        </strong>
      </p>
      <p>
        <strong>Description:</strong>
        <br />
        The Employee ECRM (Employee Enterprise Content and Relationship
        Management) project is a streamlined system designed to manage employee
        leave and facilitate communication between employees and administrators.
        Developed using <strong>
          Ruby on Rails, HTML, CSS, JavaScript,
        </strong>{" "}
        and <strong>jQuery</strong>, alongside{" "}
        <strong>integration with Slack</strong> and deployment on{" "}
        <strong>AWS</strong>, this project addresses organizational needs with
        modern technology.
      </p>

      <p>
        <strong>Key features include:</strong>
      </p>
      <p>
        1. <strong>Leave Management:</strong> Employees can submit leave
        requests, which administrators can approve, reject, revert, or set to
        pending status, ensuring smooth workflow management.
      </p>
      <p>
        2. <strong>Employee Profiles:</strong> Each employee has a profile where
        administrators can allocate leave quotas tailored to individual
        requirements for each calendar year.
      </p>
      <p>
        3. <strong>Leave Visibility:</strong> Employees can view their own leave
        history and upcoming leave schedules, fostering better planning and
        coordination within the organization.
      </p>
      <p>
        4. <strong>Real-Time Alerts:</strong> Integration with Slack sends daily
        alerts about colleagues who are on leave, enhancing communication
        efficiency.
      </p>
      <p>
        5. <strong>Location-Restricted Check-In/Check-Out:</strong> A module
        restricts check-in/check-out functionality to the office premises,
        ensuring accurate attendance tracking.
      </p>
      <p>
        6. <strong>Authentication and Authorization:</strong> A secure login
        system with role-based authorization safeguards sensitive information.
      </p>
      <p>
        7. <strong>Inventory Management:</strong> Administrators benefit from an
        integrated inventory management module, facilitating effective oversight
        and control over resources.
      </p>

      <p>
        Deployment is achieved using Capistrano with AWS deployment services,
        ensuring scalability, reliability, and security. With its intuitive
        interface and robust features, the Employee ECRM project modernizes
        leave management processes and fosters efficient communication within
        organizations.
      </p>
      <br />
      <p>
        <strong>E-Commerce Web Application (E-commerce)</strong>
      </p>
      <p>
        <strong>Description:</strong>
        <br />
        The Ruby on Rails development project utilizes the Rails framework and
        the Ruby programming language to build web applications. The project's
        data is stored and managed using the PostgreSQL database. To enhance the
        project's functionality, several gems have been implemented, including
        Devise for user authentication, Pundit for authorization, pg for
        PostgreSQL connectivity, faker for generating fake data, will_paginate
        for pagination, and will_paginate-bootstrap4 for styling pagination.
        These gems provide additional features and functionality to the project,
        making it more efficient and user-friendly.
      </p>
    </div>
  );
}

function ProjectDevntech() {
  return (
    <div>
      <p>
        <strong>Ruby on Rails Developer</strong>
      </p>
      <br />
      <p>
        <strong>Project Detail:</strong>
      </p>
      <p>
        I have been responsible for upgrading a legacy Rails application from
        version <strong>3.0.2 to 6.0</strong>. This involved a comprehensive
        analysis of the codebase, identifying and resolving compatibility
        issues, and testing the new version thoroughly to ensure seamless
        performance. I have also been responsible for daily fixes and
        improvements to the application, addressing bugs, and enhancing its
        features to meet the evolving needs of the business.
      </p>

      <p>
        In addition to the Rails upgrade, I have containerized three different
        applications using <strong>Docker</strong>, allowing for easy deployment
        and scaling of these applications in a consistent and efficient manner.
        I have worked with the development team to ensure that the applications
        are designed to be containerized from the start, making the process
        seamless and less time-consuming.
      </p>

      <p>
        Furthermore, I have started working on <strong>Nginx</strong>, a
        high-performance web server, to optimize the performance and reliability
        of the applications. This has involved configuring Nginx to serve static
        assets, handling SSL certificates, and managing the reverse proxy
        server.
      </p>
    </div>
  );
}

function ProjectWorldSrc() {
  return <div>
    <p><strong>Ruby on Rails + Flutter (Mobile Application) Developer</strong></p>
  <p><strong>Project Name:</strong> Web & Mobile Entertainment App</p>
  <p><strong>Project Description:</strong><br />
  This project aims to develop a user-friendly mobile application that caters to movie and music enthusiasts. It will leverage Flutter for a cross-platform native feel, Ruby on Rails for a robust and efficient backend, and RESTful APIs for secure communication between the app and server. Key features include:</p>

  <p><strong>Movie Exploration:</strong><br />
  • Browse a curated collection of movies.<br />
  • Filter and search for movies by genre, release date, rating, or keywords.<br />
  • View detailed movie information, including synopsis, cast, crew, and trailers.<br />
  • Add movies to a watchlist for future reference.</p>

  <p><strong>Music Library:</strong><br />
  • Access a comprehensive music library with various genres and artists.<br />
  • Search for specific songs or artists.<br />
  • Create custom playlists for personalized listening experiences.</p>

  <p><strong>Playback Functionality:</strong><br />
  • Seamlessly play movies and music within the app using integrated players.<br />
  • Implement playback controls (play, pause, rewind, fast forward, volume).<br />
  • Consider offline playback capabilities (downloadable content) for movies and music, depending on client requirements and content licensing agreements.</p>

  <p><strong>Technology Stack:</strong><br />
  • <strong>Frontend:</strong> Flutter (for a cross-platform native experience on iOS and Android)<br />
  • <strong>Backend:</strong> Ruby on Rails (for a scalable and efficient backend API)<br />
  • <strong>API Design:</strong> RESTful APIs (for secure and standardized communication between app and server)</p>

  <p><strong>Project Phases:</strong></p>
  <p><strong>1. Planning and Requirement Gathering:</strong><br />
  • Conduct thorough discussions with the client to understand their specific needs, target audience, and desired functionalities.<br />
  • Create a detailed project scope document outlining features, user stories, and timelines.</p>

  <p><strong>2. Backend Development (Ruby on Rails):</strong><br />
  • Set up the Ruby on Rails environment.<br />
  • Develop a robust database schema to store movie, music, and user data.<br />
  • Implement RESTful APIs for CRUD (Create, Read, Update, Delete) operations on movies, music, playlists, and user accounts (if applicable).<br />
  • Integrate authentication and authorization mechanisms (optional, depending on client requirements).<br />
  • Implement security measures to protect user data and API endpoints.</p>

  <p><strong>3. Frontend Development (Flutter):</strong><br />
  • Set up the Flutter development environment.<br />
  • Design a user-friendly and intuitive UI that aligns with the client's brand guidelines.<br />
  • Develop screens for movie browsing, music exploration, playback controls, and user management (if applicable).<br />
  • Integrate with the backend APIs for data fetching, user actions, and playback management.<br />
  • Implement offline functionality (if required) for downloaded movies and music.</p>

  <p><strong>4. Testing and Deployment:</strong><br />
  • Conduct thorough unit testing and integration testing for both frontend and backend components.<br />
  • Deploy the backend API to a suitable hosting platform (e.g., Heroku, AWS).<br />
  • Deploy the frontend app, follow platform-specific guidelines (App Store Connect for iOS, Google Play Store for Android).</p>

  <p><strong>5. Maintenance and Support:</strong><br />
  • Provide ongoing maintenance and support to address bugs, implement new features, and adapt to changing requirements.</p>

  <p><strong>Additional Considerations:</strong></p>
  <p><strong>• Content Management System (CMS):</strong> Consider integrating a CMS (e.g., Strapi) to allow the client to easily manage and update content without requiring code changes.<br />
  • <strong>Third-Party APIs:</strong> Explore potential integration with third-party APIs for movie trailers, music streaming services (if applicable), or user authentication (e.g., Firebase Authentication).<br />
  • <strong>Scalability and Performance:</strong> Design the architecture to accommodate future growth in user base and data volume. Utilize caching mechanisms and optimize database queries for optimal performance.</p>
  </div>;
}

export { ProjectSouthville, ProjectDevntech, ProjectWorldSrc, ProjectBayt };
